export default {
  colorScheme: '配色スキーム',
  themeSettings: 'テーマ設定',
};
